import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const XIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
       width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
        <path d="M21.2641 0.0012207H25.4042L16.3592 10.1663L27 23.9988H18.6683L12.1427 15.6095L4.67586 23.9988H0.533142L10.2078 13.126L0 0.0012207H8.54313L14.4418 7.66938L21.2641 0.0012207ZM19.811 21.5621H22.1051L7.29664 2.30989H4.83478L19.811 21.5621Z" fill="white"/>
    </SvgIcon>
  )
}
